import React,{useState, useEffect} from 'react'
import {Row,Col} from 'react-bootstrap'
import Dropdown from 'react-dropdown';
import {BsChevronDown} from 'react-icons/bs'
import { attendanceDatateacher } from '../../../../utils/DashboardApi/TeacherDashboardApi'
import PillSmall from '../../../subComponents/CustomSubComponents/PillSmall'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const TeaAttdDashTab = () => {
    const [drproutinetype,setdrproutinetype] = useState("")
    const Optionroutinetype = [
        'week','Month','Year'
      ];
      const [drpday,setDrpday] = useState("")
    
      const defaultOptionroutinetype = Optionroutinetype[0];
      const dropdownvalueroutinetype=(e)=>{
        // console.log(e.value)
        setdrproutinetype(e.value)
        console.log(drpday)
      }
      const [startDate,setStartDate] = useState("")
      const handleStartDate=(e)=>{
        setStartDate(e.target.value)
        console.log(startDate)
      }
    const [endDate,setEndtDate] = useState("")
      const handleEndDate=(e)=>{
        setEndtDate(e.target.value)
        console.log(endDate)
      }
    const [attendanceId, setattendanceId] = useState("");
    const [punchDate, setpunchDate] = useState("");
    const [officeTime, setofficeTime] = useState("");
    const [inTime, setinTime] = useState("");
    const [outTime, setoutTime] = useState("");
    const [attendanceresponse, setAttendanceresponse] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {

        //let jwttoken = sessionStorage.getItem('jwttoken');
        //console.log(jwttoken);
        if (window.token == null) {
            navigate("/login");
        }
        else {
            const fetchEmpAttendance = async () => {
                try {
                    const myresponse = await axios.get(
                        "https://localhost:7229/api/Attendance/GetEmployeeAttendance", {
                            headers: {
                                'Authorization': 'bearer ' + window.token
                            },
                    }
                    )
                    console.log(myresponse)
                    setAttendanceresponse(myresponse.data);
                } catch (err) {
                    if (err.response) {
                        console.error(err.response.data);
                        console.log(err.response.status);
                        console.log(err.response.header);
                    } else {
                        console.error(`Error: ${err.message}`);
                    }
                }
            };
            fetchEmpAttendance();
            console.log(attendanceresponse.data);
        }

    }, []);
  return (
    <>
      <div className="bodycolorbg">
        <div className="mobilecontainer">
          <div className="heading headingofdocumenttab">
            <h3>Attendance</h3>
          </div>
          <div className="firstboxofattTabmb">
            <Row className="firstrow">
              <Col
                xs={6}
                className="pdrightcol5"
                style={{ margin: "0 0 10px 0" }}
              >
                <p>Start Date</p>
                <input
                  type="date"
                  placeholder="start date"
                  onChange={(e) => handleStartDate(e)}
                />
              </Col>
              <Col
                xs={6}
                className="pdleftcol5"
                style={{ margin: "0 0 10px 0" }}
              >
                <p>End Date</p>
                <input
                  type="date"
                  placeholder="end date"
                  onChange={(e) => handleEndDate(e)}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="buttonview" style={{ margin: "20px 0" }}>
                  <div className="flexwrap">
                    <Row>
                      <Col xs={6} className="pdrightcol5">
                        <div className="totalpresentpill">
                          <p>Total Present : 00</p>
                        </div>
                      </Col>
                      <Col xs={6} className="pdleftcol5">
                        <div className="totalpresentpill totalabsentpill">
                          <p>Total Absent : 00</p>
                        </div>
                      </Col>
                      <Col
                        xs={6}
                        className="pdrightcol5 ps-2"
                        style={{ width: "45%", margin: "10px 0" }}
                      >
                        <div className="totalpresentpill totallatepill">
                          <p>Total Late : 00</p>
                        </div>
                      </Col>
                      <Col
                        xs={6}
                        className="pdleftcol5 pe-2"
                        style={{ width: "55%", margin: "10px 0" }}
                      >
                        <div className="totalpresentpill totalearlyleave">
                          <p>Total Early Leave : 00</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="roundwhitewrapper">
            <div className="secondboxofAttmb">
              <Row>
                <Col lg={12}>
                  <table>
                    <thead>
                      <tr>
                        {attendanceDatateacher.header.map((item, key) => {
                          return (
                            <th key={key}>
                              {item.headeritem}
                              {item.img ? <img src={item.img} alt="" /> : ""}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        //attendanceDatateacher.innerTableData.map((item,key)=>{
                            attendanceresponse?
                        attendanceresponse.map((item, key) => {
                          return (
                            <tr>
                              <td>
                                {/* {item.SL} */}
                                {item.attendanceId}
                              </td>
                              <td>
                                {/* {item.date} */}
                                {item.punchDate}
                              </td>
                              <td>
                                {/* {item.schooltime} */}
                                {item.officeTime}
                              </td>
                              <td>
                                {/* {item.intime} */}
                                {item.inTime}
                              </td>
                              <td>
                                {/* {item.outtime} */}
                                {item.outTime}
                              </td>

                              <td>
                                {item.type == "Present" ? (
                                  <PillSmall
                                    class={item.type}
                                    fontsize="12px"
                                    text={item.type}
                                    bg="rgba(0, 202, 85, 0.05)"
                                    textcolor="rgba(0,202,85, 1)"
                                  />
                                ) : item.type == "Late" ? (
                                  <PillSmall
                                    class={item.type}
                                    fontsize="12px"
                                    text={item.type}
                                    bg=" rgba(255, 173, 0, 0.05)"
                                    textcolor="rgba(255, 173, 0, 1)"
                                  />
                                ) : item.type == "Early Leave" ? (
                                  <PillSmall
                                    class="Earlyleave"
                                    fontsize="12px"
                                    text={item.type}
                                    bg="rgba(100, 158, 255, 0.05)"
                                    textcolor="rgba(100, 158, 255, 1)"
                                  />
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          );
                        })
                        :""
                      }
                    </tbody>
                  </table>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TeaAttdDashTab